var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"py-3"},[_c('b-row',[_c('b-col',[_c('auth-form',{staticClass:"mt-3",attrs:{"page":"verifyverificationcode"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }